<template>
  <div class="markettrends-tabs">
    <div class="static-gs market-col-2 marketTrendsTabBlock" v-if="widgetOptions && widgetOptions.type === 'vwidgethearstmarketinsight'">
      <marketTrendsDropdown :options="getTrendsData" v-if="selectedTabForDropDown.name" :selectedItem="selectedTabForDropDown" @changed="selectTab"
      class="trend-metrics-drop-down"></marketTrendsDropdown>
        <ul class='tabs-header' ref="trendMetricsTab">
          <li v-for='(tab, index) in tabs' class="trend-metrics-tab"
                :key='tab.props.data.metric.metric_title' :class='{"selected": (index == selectedTabIndex)}' @click='selectTab(index)'>
                    <marketTrendsTabHeader :tabHeader="tab.props.data.metric" :isWidget="true"></marketTrendsTabHeader>
              </li>
        </ul>
    </div>
    <div v-else>
      <div>
          <ul class="tab tab-bookmark" ref="tabsChart" role="tablist">
              	<li v-for='tab in marketTrendTabs' role="tab">
                  	<a @click='selectTabMarket(tab)' :class="{active: tab.id == selectedTabId}" >{{tab.name}}</a>
             	</li>
          </ul>
        </div>
    </div>
    <div class="tabs" tabindex="0" role="tabpanel">
      <slot></slot>
    </div>
  </div>
</template>

<script src="./markettrends-tabs.js"></script>
<style lang="scss">
@use './markettrends-tabs.scss' as *;
</style>